"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _vueTypes = _interopRequireDefault(require("ant-design-vue/es/_util/vue-types"));
var _vuePropertyDecorator = require("vue-property-decorator");
require("./style.scss");
var _dec, _class, _InputDeptSearch;
const InputDeptSearchProps = {
  userId: _vueTypes.default.string,
  deptId: _vueTypes.default.string,
  data: _vueTypes.default.func.isRequired
};
let InputDeptSearch = exports.default = (_dec = (0, _vuePropertyDecorator.Component)({
  props: InputDeptSearchProps
}), _dec(_class = (_InputDeptSearch = class InputDeptSearch extends _vuePropertyDecorator.Vue {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "inputValue", '');
    (0, _defineProperty2.default)(this, "deptSearchData", {});
    (0, _defineProperty2.default)(this, "loading", false);
    (0, _defineProperty2.default)(this, "_visible", false);
  }
  get visible() {
    return this.inputValue !== '' && this.$data._visible;
  }
  set visible(value) {
    this.$data._visible = value;
  }
  clear(force) {
    // 清空搜索条件
    if (force) {
      this.emitSearch({
        userId: null
      });
    } else {
      this.$vnode.context.searchParams.userId = null;
    }
    this._dirty = false;
  }
  beforeCreate() {
    const handleSearch = async name => {
      try {
        if (this.inputValue) {
          this.loading = true;
          this.deptSearchData = await this.data({
            name
          });
        }
      } finally {
        this.loading = false;
      }
    };
    this.handleSearch = _.debounce(handleSearch, 500);
  }
  emitSearch(payload) {
    const {
      userId,
      deptId
    } = this;
    this._dirty = true;
    this.$emit('search', {
      userId,
      deptId,
      ...payload
    });
  }
  render() {
    const h = arguments[0];
    const {
      visible,
      loading,
      deptSearchData
    } = this;
    return h("ADropdown", {
      "attrs": {
        "visible": visible,
        "overlay": loading || _.isEmpty(deptSearchData.depts) && _.isEmpty(deptSearchData.users) ? h("ACard", {
          "attrs": {
            "bordered": false
          }
        }, [h("ASpin", {
          "attrs": {
            "spinning": loading
          }
        }, [h("AEmpty", {
          "attrs": {
            "description": "无匹配数据"
          }
        })])]) : h("AMenu", [!_.isEmpty(deptSearchData.depts) && h("AMenuItemGroup", {
          "attrs": {
            "title": "部门"
          },
          "class": "menu-item"
        }, [_.map(deptSearchData.depts, (dept, i) => h("AMenuItem", {
          "key": i,
          "on": {
            "click": () => {
              this.emitSearch(dept);
            }
          }
        }, [(dept.ancestorsName && `${dept.ancestorsName.replace(/,/g, '/')}/`) + dept.deptName]))]), h("AMenuDivider"), !_.isEmpty(deptSearchData.users) && h("AMenuItemGroup", {
          "attrs": {
            "title": "用户"
          },
          "class": "menu-item"
        }, [_.map(deptSearchData.users, (user, i) => h("AMenuItem", {
          "key": i,
          "on": {
            "click": () => {
              this.emitSearch(user);
            }
          }
        }, [(user.deptName && `${user.deptName}/`) + user.userName]))])])
      }
    }, [h("div", {
      "class": "flex flex-align-center"
    }, [h("AInputSearch", {
      "attrs": {
        "allowClear": true,
        "placeholder": "搜索部门和员工"
      },
      "on": {
        "change": e => {
          if (e.target.value) {
            this.handleSearch(e.target.value);
          } else if (this._dirty) {
            this.clear(true);
          }
        },
        "focus": () => {
          this.visible = true;
        },
        "blur": () => {
          // fix: MenuItem click event handler 不会被触发 当 Dropdown closed (chrome)
          _.delay(() => {
            this.visible = false;
          }, 300);
        }
      },
      "model": {
        value: this.inputValue,
        callback: $$v => {
          this.inputValue = typeof $$v === "string" ? $$v.trim() : $$v;
        }
      }
    })])]);
  }
}, (0, _defineProperty2.default)(_InputDeptSearch, "props", InputDeptSearchProps), _InputDeptSearch)) || _class);